var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3373_13882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.426 2.40137V5.85083H9.97656",
    stroke: "#E8B73D",
    strokeWidth: 1.14982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.777344 11.5999V8.15039H4.22681",
    stroke: "#E8B73D",
    strokeWidth: 1.14982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22037 5.27623C2.51195 4.45226 3.0075 3.71558 3.66079 3.13493C4.31408 2.55428 5.10381 2.14858 5.9563 1.95569C6.80879 1.76281 7.69625 1.78902 8.53587 2.03188C9.37549 2.27474 10.1399 2.72634 10.7578 3.34453L13.4254 5.85114M0.777344 8.15078L3.44493 10.6574C4.06281 11.2756 4.82723 11.7272 5.66685 11.97C6.50647 12.2129 7.39393 12.2391 8.24642 12.0462C9.09891 11.8533 9.88864 11.4476 10.5419 10.867C11.1952 10.2863 11.6908 9.54966 11.9823 8.72569",
    stroke: "#E8B73D",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3373_13882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7979,
    height: 13.7979,
    fill: "white",
    transform: "translate(0.203125 0.101562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.59015a139c9188ad7af9afd6afc74e13.svg";
export { ForwardRef as ReactComponent };